import styled from "styled-components";

export const StyledErrorWrapper = styled.div`
  flex-direction: column;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const StyledIcon = styled.h3`
  font-style: normal;
  font-weight: 700;
  font-size: 100px;
  line-height: 100px;
  text-align: center;
  margin-bottom: 12px;
  height: 100px;
`;

export const StyledErrorTitle = styled.h4`
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  line-height: 25px;
  text-align: center;
  color: #2e3538;
`;

export const StyledErrorDescription = styled.p`
  font-style: normal;
  font-weight: 400;
  font-size: 13px;
  line-height: 18px;
  text-align: center;
  color: #2e3538;
`;
